// Module
var code = ` <select
   ng-model="\$ctrl.innerModel"
   ng-options="o.value as o.label for o in \$ctrl.getEffectiveOptions()"
   ng-change="\$ctrl.innerModelChange()"
   required>
 </select>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/common/product/fee-overdraft-strategy/fee-overdraft-strategy.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;